import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getAccountPurposes, saveBatchAccountPurposes } from '../../api/accountPurposes';
import type { AccountPurpose } from '../../types/AccountPurpose';
import { t } from '../../i18n/t';

const columnDefs: ColDef<AccountPurpose>[] = [
  {
    field: 'accountPurposeId',
    headerName: t('accountPurposes.columns.accountPurposeId'),
    width: 140,
    cellDataType: 'number',
    editable: (p: EditableCallbackParams<AccountPurpose>) =>
      (p.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'accountPurposeName', headerName: t('accountPurposes.columns.accountPurposeName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<AccountPurpose> => ({ accountPurposeId: 0, accountPurposeName: '' });

export function AccountPurposesPage() {
  return (
    <LopCrudPage<AccountPurpose>
      resourceCode="accountPurposes"
      titleKey="accountPurposes.pageTitle"
      idField="accountPurposeId"
      getRows={getAccountPurposes}
      saveBatch={(added, modified, deletedIds) => saveBatchAccountPurposes(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
